export default {
  required: {
    id: 'buyback_shared_required_field',
    defaultMessage: 'This field is required',
  },
  accountNumberError: {
    id: 'buyback_merchant_update_bacs_account_number_error',
    defaultMessage: 'Your bank account number must be {length} digits long.',
  },
  accountNumber: {
    id: 'buyback_merchant_update_bacs_account_number',
    defaultMessage: 'Bank account number',
  },
  accountNumberDescription: {
    id: 'buyback_merchant_update_bacs_account_number_description',
    defaultMessage: 'E.g. 40308669',
  },
  sortCodeError: {
    id: 'buyback_merchant_update_bacs_sorting_code_error',
    defaultMessage: 'Your sorting code must be {length} digits long.',
  },
  sortCode: {
    id: 'buyback_merchant_update_bacs_sort_code_label',
    defaultMessage: 'Sort Code',
  },
  sortCodeDescription: {
    id: 'buyback_merchant_update_bacs_sort_code_description',
    defaultMessage: 'E.g. 560036',
  },
  formSubmitButton: {
    id: 'buyback_bank_form_submit',
    defaultMessage: 'Continue',
  },
  ownerLabel: {
    id: 'buyback_merchant_update_bacs_owner_label',
    defaultMessage: 'Account holder',
  },
  ownerDescription: {
    id: 'buyback_merchant_update_bacs_owner_description',
    defaultMessage: 'E.g. Jhon Doe',
  },
  emailDescription: {
    id: 'buyback_merchant_update_bacs_email_description',
    defaultMessage: 'E.g. jhon.doe@gmail.com',
  },
  emailLabel: {
    id: 'buyback_merchant_update_bacs_email_label',
    defaultMessage: 'Email',
  },
}
